export default __webpack_public_path__ + "static/media/background.1f7dd9a6.jpg";